import React from 'react';

// A button that is really a link: a plain left click runs `onClick` in place
// (no reload, editor state kept), while a middle click, Cmd/Ctrl/Shift-click or
// "Open in new tab" from the context menu is left to the browser, which opens
// `href` in a new tab. Without an `href`, or when disabled, it is an ordinary
// button.
const LinkButton = ({ href, onClick, disabled, children, ...rest }) => {
  if (!href || disabled) {
    return (
      <button type="button" onClick={onClick} disabled={disabled} {...rest}>
        {children}
      </button>
    );
  }
  const handleClick = (e) => {
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    if (onClick) onClick(e);
  };
  return (
    <a href={href} onClick={handleClick} {...rest}>
      {children}
    </a>
  );
};

export default LinkButton;
